
<template>

	<b-overlay :show="wait" class="d-flex flex-column h-100">

		<b-row v-resize v-on:resize="update_charts">

			<b-col style="min-width: 50%;">

				<myframe title="Структура группы по методам определения кадастровой стоимости" without_border>

					<div v-if="stat_response" class="mt-2">Общее количество объектов {{ stat_response.stat.objects_count }}, из них для {{ stat_response.stat.objects_count_without_cost_evaluation }} метод не выбран</div>

					<!-- <GChart v-if="cost_evaluation_type_data.length > 1" type="BarChart" :settings="{ packages: [ 'corechart' ], language: 'en' }" :options="cost_evaluation_type_options" :data="cost_evaluation_type_data"/> -->

					<progress_chart
						v-if="cost_evaluation_type.length > 0" :total="total" :stats="cost_evaluation_type"
						class="mt-2"
						good_stat_legend="Количество рассчитанных"
						bad_stat_legend="Количество не рассчитанных"
					/>

				</myframe>

			</b-col>

			<b-col style="min-width: 50%;">

				<myframe title="Структура группы по составу объектов недвижимости" without_border>

					<GChart v-if="object_type_data.length > 1" type="PieChart" :settings="{ packages: [ 'corechart' ], language: 'ru' }" :options="object_type_options" :data="object_type_data"/>

				</myframe>

			</b-col>

		</b-row>

		<result :id="id" />

	</b-overlay>

</template>

<script>

import { GChart } from "vue-google-charts"
import api from "../../../../api"
import myframe from "../../../widgets/frame"
import result from "./result"
import progress_chart from "../../../widgets/progress_chart"

export default
{
	components :
	{
		GChart,
		myframe,
		// date_picker,
		result,
		progress_chart
	},

	// props :
	// {
	// 	id : String,
	// 	data : Object,
	// },

	data()
	{
		return {
			
			service : "cadastral_groups",
			id : null,

			wait : false,
			stat_response : null,

			// cost_evaluation_type_data : [],
			object_type_data : [],

			// cost_evaluation_type_options : {
			// 	legend : { position : "bottom" },
			// 	chartArea : { width : "70%", left : 212 },
			// 	vAxis : { textStyle: { fontSize: 12 } },
			// 	hAxis : { format: '#' },
			// 	colors : [ "#BFDEFF", "#007CFF" ],
			// 	tooltip: {isHtml: true},
			// 	isStacked: true,
			// 	annotations : { textStyle: { auraColor: 'none' } }
			// },
			object_type_options : {
				legend : { position : "left", alignment : "center" }, 
				chartArea : { width : "100%", height : "100%" }, 
				sliceVisibilityThreshold : 0, 
				is3D : true, 
				pieSliceText : "value",
				tooltip: {isHtml: true}
			},

			object_type_colors :
			{
				"002001001000" : "#007CFF",
				"002001002000" : "#00CAFF",
				"002001003000" : "#22c55e",
				"002001004000" : "#FACC15",
				"002001005000" : "#EF4444",
				"002001006000" : "#3B3EAC",
				"002001008000" : "#22AA99",
				"002001009000" : "#06B6D4",
				"002001010000" : "#994489",
			},

			total : null,
			cost_evaluation_type : []
		}
	},

	// watch :
	// {
	// 	id :
	// 	{
	// 		immediate : true,

	// 		handler()
	// 		{
	// 			this.refresh()
	// 		}
	// 	},
	// },

	created() 
	{
		this.id = this.$route.params.id

		this.refresh()
	},

	methods :
	{
		update_charts()
		{
			this.refresh()
		},

		refresh()
		{
			// if(this.id == null)
			// 	return

			this.wait = true

			var process_func =
				response =>
				{
					const stat = response.stat

					// var cost_evaluation_type_data = [ [
					// 	"Метод определения КС",
					// 	"Количество не рассчитанных", { role : "annotation" },
					// 	"Количество рассчитанных", { role : "annotation" }
					// ] ]
					var object_type_data = []
					var object_type_slices = []

					var entries = Object.entries(stat.cost_evaluation_type)
					var stat_cost_evaluation_type = api.sort_objects_array_by_key(entries, 1)

					// stat_cost_evaluation_type.forEach(
					// 	desc =>
					// 	{
					// 		const type = desc[0]
					// 		const value = desc[1]
					// 		const percent = api.round2(( 100. * value ) / stat.objects_count)
					// 		const not_cost_value = stat.objects_count - value
					// 		const not_cost_percent = api.round2(( 100. * not_cost_value ) / stat.objects_count)
					// 		cost_evaluation_type_data.push([ type, not_cost_percent, `${not_cost_value} (${not_cost_percent} %)`, percent, `${value} (${percent} %)` ])
					// 	})

					this.cost_evaluation_type = stat_cost_evaluation_type.map((stat_item) => {
						return [
							...stat_item,
							stat.cost_evaluation_type_not_calculated[stat_item[0]]
						]
					})

					Object.entries(stat.object_type).forEach(
						desc =>
						{
							const type = desc[0]
							const value = desc[1]
							const percent = api.round2(( 100. * value ) / stat.objects_count)
							const label = `${percent} % - ${type}`
							const type_fields = type.match(".* \\((.*)\\)") 
							const code = type_fields ? type_fields[1] : type

							object_type_data.push([ label, value, api.get_tooltip(label, "", `${value} (${percent}%)`) ])
							object_type_slices.push({ color : this.object_type_colors[code] })
						})

					object_type_data = api.sort_objects_array_by_key(object_type_data, 1, true)
					object_type_data = [ [ "Вид ОО", "Количество в процентах", { role : "tooltip", p: {html: true} } ], ...object_type_data ]

					// this.cost_evaluation_type_data = cost_evaluation_type_data
					this.object_type_options.slices = object_type_slices
					this.object_type_data = object_type_data
					this.wait = false
				}

			if(this.stat_response == null)
			{
				api.call(this, this.service, "get_general_statistics", { id : this.id },
					response =>
					{
						this.stat_response = response
						process_func(response)
					})
			}
			else
				process_func(this.stat_response)
		},
	}
}

</script>
